import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-dashboard-square-01-Stroke',
  standalone: true,
  templateUrl: '../../assets/dashboard-square-01/Stroke.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamDashboardSquare01StrokeIcon {}
